import { request } from './api'

export interface Theme {
  id: string
  name: string
  description: string | null
  is_default: boolean
  is_system: boolean
  light_colors: Record<string, string>
  dark_colors: Record<string, string>
  preview_colors: Record<string, string> | null
  created_at: number
  updated_at: number
}

export interface ThemeCreate {
  name: string
  description?: string | null
  is_default?: boolean
  light_colors: Record<string, string>
  dark_colors: Record<string, string>
  preview_colors?: Record<string, string> | null
}

export interface ThemeUpdate {
  name?: string
  description?: string | null
  is_default?: boolean
  light_colors?: Record<string, string>
  dark_colors?: Record<string, string>
  preview_colors?: Record<string, string> | null
}

export const themesApi = {
  list: () => request<Theme[]>('/themes'),

  getDefault: () => request<Theme>('/themes/default'),

  get: (id: string) => request<Theme>(`/themes/${encodeURIComponent(id)}`),

  create: (data: ThemeCreate) =>
    request<Theme>('/themes', {
      method: 'POST',
      body: JSON.stringify(data),
    }),

  update: (id: string, data: ThemeUpdate) =>
    request<Theme>(`/themes/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),

  delete: (id: string) =>
    request<void>(`/themes/${id}`, {
      method: 'DELETE',
    }),

  setDefault: (id: string) =>
    request<Theme>(`/themes/${id}/set-default`, {
      method: 'POST',
    }),
}
